var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardRegInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16175_105544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 6.30278H32.3389V0.5H22.9778V3.11944H15.3194V7.61944H9.36111V0.5H0V40.5H40V6.30278ZM7.65833 35.175H1.70278V5.83333H7.65833V35.175ZM7.65833 2.20278V4.13056H1.70278V2.20278H7.65833ZM1.70556 38.7972V36.8889H7.65833V38.8056L1.70556 38.7972ZM9.36389 38.7972V9.325H15.3167V38.7972H9.36389ZM17.0222 38.7972V4.82222H22.9778V38.7972H17.0222ZM24.6806 5.83333H30.6361V35.175H24.6833L24.6806 5.83333ZM30.6361 2.20278V4.13056H24.6806V2.20278H30.6361ZM24.6833 38.7972V36.8889H30.6361V38.8056L24.6833 38.7972ZM32.3417 38.7972V8H38.2944V38.7972H32.3417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1335 35.175H17.8696V36.8778H22.1335V35.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1335 31.9417H17.8696V33.6444H22.1335V31.9417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1335 8.83057H17.8696V10.5333H22.1335V8.83057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16175_105544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRegInventory);
export default __webpack_public_path__ + "static/media/dashboard-reg-inventory.9a8ad866bc0445e2f54791aeaf46fe7d.svg";
export { ForwardRef as ReactComponent };